import { useTranslation } from "react-i18next";
import { Button } from "antd";
import styles from "./index.module.scss";

const LdapLogin = () => {
  const { t } = useTranslation();

  const handleLDAPLogin = () => {
    window.location.href =
      "https://sso.sensetime.com/enduser/sp/sso/sensetimeplugin_jwt91?enterpriseId=sensetime";
  };

  return (
    <div>
      <div className={styles.title}>
        {t("sensechat-119")}
        {/* 欢迎使用 SenseChat */}
      </div>
      <Button onClick={handleLDAPLogin} type="primary">
        ldap登录
      </Button>
    </div>
  );
};

export default LdapLogin;
